import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { KineticText } from "@/components/KineticText";

const cities = ["Lisbon", "Porto", "Braga", "Madeira"];

export function SceneArrival() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 0.6], [1.3, 1]);
  const opacity = useTransform(scrollYProgress, [0, 0.4], [0.25, 1]);
  const textY = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);

  return (
    <section ref={ref} data-testid="scene-arrival" className="relative h-[130vh] overflow-hidden bg-maroon-deep">
      <motion.div style={{ scale, opacity }} className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1608208291890-dcaf52dc98e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
          alt="Aerial view of Lisbon, Portugal at golden hour — the moment of arrival"
          className="h-full w-full object-cover"
          style={{ filter: "sepia(0.4) saturate(1.35) hue-rotate(-8deg)" }}
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-maroon-deep via-maroon-deep/30 to-maroon-deep/75 mix-blend-multiply" />
        <div className="absolute inset-0 bg-gradient-to-t from-maroon-deep via-transparent to-maroon-deep/40" />
      </motion.div>

      <motion.div style={{ y: textY }} className="relative h-full flex flex-col items-center justify-center text-center px-6">
        <p className="accent-eyebrow text-gold">Arrival · Portugal</p>
        <KineticText as="h2" text="The wheels touch the runway." className="font-playfair text-4xl md:text-6xl lg:text-7xl text-cream mt-6 leading-[1.03] font-semibold" />
        <KineticText as="h2" text="And the runway becomes your roadmap." className="font-playfair italic text-gradient-gold text-4xl md:text-6xl lg:text-7xl leading-[1.03]" delay={0.15} />

        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          {cities.map((c, i) => (
            <motion.span key={c} initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 + i * 0.12 }} className="rounded-full border border-gold/40 bg-maroon/40 glass-nav px-5 py-2 text-sm text-cream/85">
              {c}
            </motion.span>
          ))}
        </div>
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.6 }} className="text-cream/65 text-lg mt-10 max-w-xl">
          Ten milestones. One journey. From your first idea to a future built and growing.
        </motion.p>
      </motion.div>
    </section>
  );
}
